/* NSC product page: gallery, purchase-option sync and sticky purchase bar.
   Cart, Buy Now and variant switching stay with the theme's own product-form logic (theme.js);
   this file only drives the gallery and keeps the extra UI in sync with the selected variant. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  $$('[data-nscp]').forEach(function (root) {
    /* ---------------- Gallery ---------------- */
    var stage = $('[data-nscp-stage]', root);
    var slides = $$('[data-nscp-slide]', root);
    var thumbs = $$('[data-nscp-thumb]', root);
    var current = 0;

    function stopExternal(slide) {
      var ext = $('[data-nscp-ext]', slide);
      var frame = ext && $('iframe', ext);
      if (frame) { frame.remove(); ext.classList.remove('is-playing'); }
    }

    function go(i, opts) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      slides.forEach(function (sl, k) {
        var on = k === i;
        sl.classList.toggle('is-active', on);
        var v = $('video', sl);
        if (v && !on) v.pause();
        if (!on) stopExternal(sl);
      });
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && t.scrollIntoView && !(opts && opts.silent)) {
          var strip = t.parentElement;
          var left = t.offsetLeft - (strip.clientWidth - t.clientWidth) / 2;
          strip.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      });
      current = i;
      var v2 = $('video', slides[i]);
      if (v2 && !(opts && opts.silent)) {
        var p = v2.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-nscp-thumb'), 10) || 0); });
    });
    var prev = $('[data-nscp-prev]', root), next = $('[data-nscp-next]', root);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    if (stage) {
      stage.addEventListener('keydown', function (e) {
        if (e.target !== stage) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      });
      /* Swipe. Touches on a video's control bar are left to the player. */
      var sx = 0, sy = 0, track = false;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { track = false; return; }
        var t = e.touches[0], r = stage.getBoundingClientRect();
        var onVideo = slides[current] && $('video', slides[current]);
        track = !(onVideo && t.clientY > r.bottom - 56);
        sx = t.clientX; sy = t.clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!track) return; track = false;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        go(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    /* External (YouTube/Vimeo) media: load the player only on request. */
    $$('[data-nscp-ext-play]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ext = btn.closest('[data-nscp-ext]');
        if (!ext || $('iframe', ext)) return;
        var f = document.createElement('iframe');
        f.src = ext.getAttribute('data-embed');
        f.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        f.setAttribute('allowfullscreen', '');
        f.title = 'Product video';
        ext.appendChild(f);
        ext.classList.add('is-playing');
      });
    });

    /* Full screen: native full screen for video, a lightbox for images. */
    var zoom = $('[data-nscp-zoom]', root);
    var lb = $('[data-nscp-lightbox]', root);
    if (zoom) {
      zoom.addEventListener('click', function () {
        var slide = slides[current] || $('.nscp-slide.is-active', root);
        var v = slide && $('video', slide);
        if (v) {
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          if (v.requestFullscreen) v.requestFullscreen().catch(function () {});
          else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen();
          return;
        }
        var img = slide && $('img', slide);
        if (!img || !lb || typeof lb.showModal !== 'function') return;
        var big = $('[data-nscp-lightbox-img]', lb);
        big.src = img.getAttribute('data-full') || img.currentSrc || img.src;
        big.alt = img.alt;
        lb.showModal();
      });
    }
    if (lb) {
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.closest('[data-nscp-lightbox-close]')) lb.close();
      });
    }

    /* ---------------- Purchase options ---------------- */
    var form = $('[data-product-form]', root);
    var mainPrice = form && $('[data-product-price]', form);
    var notes = $$('[data-nscp-optnote]', root);
    var sticky = $('[data-nscp-sticky]', root);
    var stickyPrice = sticky && $('[data-nscp-sticky-price]', sticky);
    var stickySelect = sticky && $('[data-nscp-sticky-option]', sticky);

    function selectedValues() {
      return $$('[data-option-index]', form).map(function (g) {
        var a = $('.option-value.is-active', g);
        return a ? a.getAttribute('data-value') : '';
      });
    }
    function syncOptions() {
      if (!form) return;
      $$('.option-value', form).forEach(function (b) {
        b.setAttribute('aria-pressed', b.classList.contains('is-active') ? 'true' : 'false');
      });
      var joined = selectedValues().join(' / ').toLowerCase();
      notes.forEach(function (n) { n.hidden = joined.indexOf(n.getAttribute('data-nscp-optnote')) === -1; });
      if (stickySelect) {
        var first = selectedValues()[0];
        if (first) stickySelect.value = first;
      }
      if (stickyPrice && mainPrice) stickyPrice.textContent = mainPrice.textContent;
    }
    if (form) {
      form.addEventListener('click', function (e) {
        if (e.target.closest('.option-value')) setTimeout(syncOptions, 0);
      });
    }
    if (mainPrice && 'MutationObserver' in window) {
      new MutationObserver(syncOptions).observe(mainPrice, { childList: true, characterData: true, subtree: true });
    }
    syncOptions();

    /* ---------------- Sticky purchase bar ---------------- */
    if (!sticky || !form) return;
    var KEY = 'nscp-sticky-hidden';
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(KEY) === '1'; } catch (err) {}
    var ctas = $('.nscp-ctas', root);

    /* Keep clear of fixed widgets near the bottom of the screen (default: the Postscript SMS popup). */
    var avoidSel = sticky.getAttribute('data-avoid') || '#ps__widget';
    var avoidTimer = null;
    function avoid() {
      sticky.style.paddingLeft = '';
      sticky.style.bottom = '';
      if (!sticky.classList.contains('is-visible')) return;
      var vh = window.innerHeight, vw = window.innerWidth;
      $$(avoidSel).forEach(function (el) {
        var r = el.getBoundingClientRect();
        var visH = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
        if (r.width < 1 || visH < 1 || r.bottom < vh - 140) return;
        if (r.width < vw * 0.5 && r.left < vw * 0.5) sticky.style.paddingLeft = Math.round(r.right + 12) + 'px';
        else sticky.style.bottom = Math.round(visH) + 'px';
      });
    }
    function setVisible(on) {
      on = on && !dismissed;
      if (on) sticky.hidden = false;
      sticky.classList.toggle('is-visible', on);
      document.body.classList.toggle('nscp-sticky-on', on);
      avoid();
      clearInterval(avoidTimer);
      if (on) avoidTimer = setInterval(avoid, 1500);
    }
    window.addEventListener('resize', avoid);
    if (ctas && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        setVisible(!en.isIntersecting && en.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(ctas);
    }
    var sBuy = $('[data-nscp-sticky-buy]', sticky);
    if (sBuy) sBuy.addEventListener('click', function () {
      var b = $('[data-buy-now]', form);
      if (b && !b.disabled) b.click();
    });
    if (stickySelect) stickySelect.addEventListener('change', function () {
      var group = $('[data-option-index="0"]', form);
      var match = group && $$('.option-value', group).filter(function (b) { return b.getAttribute('data-value') === stickySelect.value; })[0];
      if (match) match.click();
    });
    var close = $('[data-nscp-sticky-close]', sticky);
    if (close) close.addEventListener('click', function () {
      dismissed = true;
      try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
      setVisible(false);
    });
  });
})();
